import React, { useState } from 'react';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN || "https://7520ce8658780aa9974e2ac9bc9f385d@o126170.ingest.sentry.io/4510273036484608", // default live Sentry DNS
  beforeSend(event) {
    try {
      const message = event?.exception?.values?.[0]?.value || "";
      const stack = JSON.stringify(event?.exception?.values?.[0]?.stacktrace || {});
      const breadcrumbs = event?.breadcrumbs || [];

      const hasNewRelicWarning = breadcrumbs.some(
        b => b.message?.includes("New Relic Warning")
      );

      if (
        message.includes("Timeout") &&
        (stack.includes("nr-data.net") || stack.includes("newrelic") ||
        hasNewRelicWarning)
      ) {
        return null;
      }

      if (message.includes("New Relic Warning")) {
        return null;
      }

      if (message.includes("antifingerprint not defined")) {
        return null;
      }
    } catch (e) {
      return event;
    }
    return event;
  },
});

const SentryErrorBoundary = ({ children }) => {
    const [error, setError] = useState(null);

    return (
        <Sentry.ErrorBoundary
            fallback={({ error, componentStack, resetError }) => (
                <div>
                    There appears to be an issue at the moment.
                    Information has been forwarded to the technical support team, and we are looking into it.
                    <button onClick={resetError}>Try Again</button>
                </div>
            )}
            onReset={() => setError(null)}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
};

export default SentryErrorBoundary;
